import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Loader, MapPin, Search, X } from 'lucide-react';

const SearchSection = ({
  wrapperRef,
  onSubmit,
  query,
  handleSearchChange,
  suggestions,
  loadingSuggestions,
  setShowDropdown,
  resetAll,
  showDropdown,
  onSelectSuggestion,
  searchError
}) => (
  <div className="search-section" ref={wrapperRef}>
    <form className="search-wrapper" onSubmit={onSubmit}>
      <Search className="search-icon" />
      <input
        type="text"
        className="search-field"
        placeholder="Search your business name and city..."
        value={query}
        onChange={(event) => handleSearchChange(event.target.value)}
        onFocus={() => {
          if (query.trim().length >= 2 && (suggestions.length > 0 || loadingSuggestions)) {
            setShowDropdown(true);
          }
        }}
      />
      {query && (
        <button className="clear-btn" type="button" onClick={resetAll} aria-label="Clear search">
          <X size={18} />
        </button>
      )}
      {/* Honeypot field — invisible to humans, scraped by naive bots. */}
      <input
        type="text"
        name="website"
        data-honeypot="grader"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        defaultValue=""
        style={{ position: 'absolute', left: '-9999px', width: 0, height: 0, opacity: 0, pointerEvents: 'none' }}
      />
    </form>

    <AnimatePresence>
      {showDropdown && (
        <motion.div
          className="dropdown-menu"
          initial={{ opacity: 0, y: -6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.16, ease: [0.22, 0.61, 0.36, 1] }}
        >
          {loadingSuggestions ? (
            <div className="dropdown-loading">
              <Loader size={22} className="spin" />
              <span>Finding businesses...</span>
            </div>
          ) : suggestions.length > 0 ? (
            <div className="dropdown-list">
              {suggestions.map((business) => (
                <button
                  key={business.id || `${business.name}-${business.city}`}
                  className="dropdown-item"
                  type="button"
                  onClick={() => onSelectSuggestion(business)}
                >
                  <div className="business-item-content">
                    <div className="business-item-name">{business.name}</div>
                    <div className="business-item-meta">
                      <span className="location">
                        <MapPin size={14} />
                        {business.city || 'Local area'}
                      </span>
                      <span className="rating">★ {business.rating || 'N/A'}</span>
                    </div>
                  </div>
                  <span className="dropdown-arrow">→</span>
                </button>
              ))}
            </div>
          ) : (
            <div className="dropdown-empty">
              <small>{searchError || 'No businesses found. Try a broader search.'}</small>
            </div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export default SearchSection;
